import { IIconBase } from '..'

const receiptEditIcon = ({
  color = '#333752',
  height = 40,
  width = 40,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M34.1654 18.8332V11.7333C34.1654 5.0166 32.5987 3.33325 26.2987 3.33325H13.6987C7.3987 3.33325 5.83203 5.0166 5.83203 11.7333V30.4999C5.83203 34.9332 8.26538 35.9833 11.2154 32.8166L11.232 32.7999C12.5987 31.3499 14.682 31.4666 15.8653 33.0499L17.5487 35.2999'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.332 11.6667H26.6654'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15 18.3333H25'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M30.353 24.6171L24.453 30.5171C24.2197 30.7505 24.003 31.1838 23.953 31.5005L23.6363 33.7505C23.5196 34.5671 24.0863 35.1338 24.903 35.0172L27.153 34.7005C27.4697 34.6505 27.9197 34.4338 28.1363 34.2005L34.0363 28.3005C35.053 27.2838 35.5363 26.1005 34.0363 24.6005C32.553 23.1172 31.3696 23.6005 30.353 24.6171Z'
        stroke={color}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M29.5 25.467C30 27.267 31.4 28.667 33.2 29.167'
        stroke={color}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default receiptEditIcon
